import React, { Suspense } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import PageLoading from "./components/LoadingUi/PageLoading";
import useAuthCheck from "./hooks/useAuthCheck";

const Teams = React.lazy(() => import("./pages/Teams"));
const Register = React.lazy(() => import("./pages/Register"));
const Projects = React.lazy(() => import("./pages/Projects"));
const Login = React.lazy(() => import("./pages/Login"));
const PublicRoute = React.lazy(() => import("./components/PublicRoute"));
const PrivateRoute = React.lazy(() => import("./components/PrivateRoute"));

function App() {
  const authChecked = useAuthCheck();

  return !authChecked ? (
    <PageLoading />
  ) : (
    <Router>
      <Routes>
        <Route
          path="/"
          element={
            <Suspense fallback={<PageLoading />}>
              <PublicRoute>
                <Login />
              </PublicRoute>
            </Suspense>
          }
        />
        <Route
          path="/register"
          element={
            <Suspense fallback={<PageLoading />}>
              <PublicRoute>
                <Register />
              </PublicRoute>
            </Suspense>
          }
        />
        <Route
          path="/teams"
          element={
            <Suspense fallback={<PageLoading />}>
              <PrivateRoute>
                <Teams />
              </PrivateRoute>
            </Suspense>
          }
        />
        <Route
          path="/projects"
          element={
            <Suspense fallback={<PageLoading />}>
              <PrivateRoute>
                <Projects />
              </PrivateRoute>
            </Suspense>
          }
        />
      </Routes>
    </Router>
  );
}

export default App;
